import React from 'react';
import { Box, Typography, Button, Container, IconButton } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import GitHubIcon from '@mui/icons-material/GitHub';

function LandingPage({ onGetStarted }) {
  return (
    <Box sx={{ 
      minHeight: 'calc(100vh - 64px)', 
      display: 'flex', 
      alignItems: 'center',
      py: 8,
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Animated background elements */}
      <Box sx={{
        position: 'absolute',
        top: '10%',
        right: '10%',
        width: 300,
        height: 300,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,150,136,0.15) 0%, transparent 70%)',
        animation: 'pulse 4s ease-in-out infinite',
        '@keyframes pulse': {
          '0%, 100%': { transform: 'scale(1)', opacity: 0.5 },
          '50%': { transform: 'scale(1.1)', opacity: 0.8 }
        }
      }} />
      
      <Box sx={{
        position: 'absolute',
        bottom: '15%',
        left: '5%',
        width: 200,
        height: 200,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,150,136,0.1) 0%, transparent 70%)',
        animation: 'float 6s ease-in-out infinite',
        '@keyframes float': {
          '0%, 100%': { transform: 'translateY(0px)' },
          '50%': { transform: 'translateY(-20px)' }
        }
      }} />

      {/* GitHub Icon - Bottom Right */}
      <IconButton
        href="https://github.com/kiprutobeauttah"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: 'absolute',
          bottom: 24,
          right: 24,
          bgcolor: 'rgba(0, 150, 136, 0.2)',
          color: '#009688',
          '&:hover': {
            bgcolor: 'rgba(0, 150, 136, 0.3)',
            transform: 'scale(1.1)',
          },
          transition: 'all 0.3s ease',
          zIndex: 10
        }}
      >
        <GitHubIcon sx={{ fontSize: 32 }} />
      </IconButton>

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box sx={{ textAlign: 'center' }}>
          {/* Logo with glow effect */}
          <Box sx={{ 
            mb: 4,
            position: 'relative',
            display: 'inline-block'
          }}>
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 180,
              height: 180,
              borderRadius: '50%',
              background: 'radial-gradient(circle, rgba(0,150,136,0.3) 0%, transparent 70%)',
              filter: 'blur(20px)',
            }} />
            <img 
              src="/withoutbg.png" 
              alt="8qn-download" 
              style={{ 
                height: 140, 
                width: 'auto', 
                position: 'relative',
                filter: 'drop-shadow(0 0 20px rgba(0,150,136,0.5))'
              }}
            />
          </Box>

          {/* Title with gradient */}
          <Typography 
            variant="h1" 
            sx={{ 
              fontWeight: 800, 
              mb: 2,
              fontSize: { xs: '2.5rem', md: '4rem' },
              background: 'linear-gradient(135deg, #ffffff 0%, #009688 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '-0.02em'
            }}
          >
            8qn-download
          </Typography>

          {/* Subtitle with emphasis */}
          <Typography 
            variant="h4" 
            sx={{ 
              mb: 2,
              fontSize: { xs: '1.25rem', md: '2rem' },
              fontWeight: 600,
              color: '#ffffff'
            }}
          >
            Your Exam Papers,{' '}
            <Box component="span" sx={{ color: '#009688' }}>
              Instantly
            </Box>
          </Typography>

          <Typography 
            variant="h6" 
            color="text.secondary" 
            sx={{ 
              mb: 6,
              fontSize: { xs: '1rem', md: '1.25rem' },
              maxWidth: 600,
              mx: 'auto'
            }}
          >
            Stop wasting hours searching. Find, preview, and merge exam papers in seconds.
          </Typography>

          {/* CTA Button */}
          <Button
            variant="contained"
            size="large"
            startIcon={<RocketLaunchIcon />}
            onClick={onGetStarted}
            sx={{
              bgcolor: '#009688',
              '&:hover': {
                bgcolor: '#00796b',
                transform: 'translateY(-2px)',
                boxShadow: '0 10px 40px rgba(0, 150, 136, 0.4)'
              },
              px: 8,
              py: 2.5,
              fontSize: '1.2rem',
              borderRadius: 3,
              fontWeight: 600,
              transition: 'all 0.3s ease',
              boxShadow: '0 5px 20px rgba(0, 150, 136, 0.3)'
            }}
          >
            Start Searching Now
          </Button>

          {/* Footer Info */}
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ display: 'block', mt: 6, opacity: 0.7 }}
          >
            MUST (Meru University) • 2015-2026 • All Schools
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default LandingPage;
